import { useLinked, useModel } from "@type-r/react";
import React from "react";
import { RemittanceAdviceData } from "../../api/remittanceAdviceChange";
import { AssetsSection } from "../assets-section";
import { InblockedAssetsDataStep } from "../inblocked-assets-data-step";
import { InblockedAssetsTitle } from "../inblocked-assets-title";
import { RemittanceAdviceExternalSystems } from "./externalSystems";
import { RemittanceAdviceTile } from "./remittance-advices-tile";

export const InblockedRemittanceAdvicesDataStep =
    ({ job, back, $refreshEvents }: { job, back?, $refreshEvents}) => {
        const remittanceAdviceChanges = useModel(RemittanceAdviceData);
        const selectedRemittanceAdvices = useModel(RemittanceAdviceData);
        const $activeInvoice = useLinked(null);
        const $filter = useLinked({ search: '', eventType: null });
        const $loadedAssetEvents = useLinked(false);

        const $selectAllAssets = useLinked(false);

        return <InblockedAssetsDataStep
            assetName='Remittance Advice'
            assetChanges={remittanceAdviceChanges}
            selectedAssets={selectedRemittanceAdvices}
            $filter={$filter}
            job={job}
            back={back}
            $loadedAssetEvents={$loadedAssetEvents}
            assetsListComponent={
                (filteredAssetChanges, itemsCount, $selectAllAssets, assetEventsGeneralCount) =>
                    <AssetsSection
                        height={420}
                        title={<InblockedAssetsTitle assetChanges={remittanceAdviceChanges.items} externalSystems={RemittanceAdviceExternalSystems} $filter={$filter} $loadedAssetEvents={$loadedAssetEvents} importJobId={job.importJobId} itemsCount={itemsCount} assetEventsGeneralCount={assetEventsGeneralCount} />}
                        assets={filteredAssetChanges}
                        assetTile={RemittanceAdviceTile}
                        notExpanded={false}
                        $active={$activeInvoice}
                        selected={selectedRemittanceAdvices.items}
                        selectAllAssets={$selectAllAssets} />
            }
            $refreshEvents={$refreshEvents}
            externalSystems={RemittanceAdviceExternalSystems}
            selectAllAssets={$selectAllAssets} />
    };
